import { Draft } from '@reduxjs/toolkit';

import { ICategoryData } from '../../index';

function getAllToSelectRequest(draft: Draft<ICategoryData>) {
  draft.getAllToSelect.config.isLoading = true;
}

export default getAllToSelectRequest;
